<template>
	<div class="container mx-auto max-w-5xl px-4">
		<div class="flex flex-col justify-between">
			<div class="flex p-2">
				<HelpfulTips>
					Let us know if your car is modified in any way or has any custom features. This
					may include equipment like custom wheels, an aftermarket audio system, a tow
					hitch, or modifications like suspension, intake or exhaust alterations and more.
				</HelpfulTips>

				<div class="flex grow basis-1/2 flex-col items-center">
					<div class="mx-auto mb-6 flex w-3/4 justify-center gap-5">
						<div
							class="text-main-400 rounded-4xl xs:py-3 hover:border-main-400 mb-4 box-border flex cursor-pointer items-center justify-center gap-4 self-start border border-transparent px-8 py-2 hover:shadow-sm max-[374px]:px-4"
							:class="{
								'border-main-400 bg-main-400': !form.aftermarkets,
							}"
							@click="toggleAftermarkets(false)"
						>
							<CheckSecondSvg
								v-if="!form.aftermarkets"
								class="mb-1 h-6 w-6 fill-white"
								:class="{ 'opacity-0': form.aftermarkets }"
							/>

							<div
								v-else
								class="h-[27px] w-[27px] rounded-full border border-gray-300"
							/>

							<span
								class="text-xl font-bold"
								:class="{ 'text-white': form.aftermarkets !== true }"
							>
								No
							</span>
						</div>

						<div
							class="text-main-400 xs:py-3 rounded-4xl hover:border-main-400 mb-4 box-border flex cursor-pointer items-center justify-center gap-4 self-start border border-transparent px-8 py-2 hover:shadow-sm max-[374px]:px-4"
							:class="{
								'border-main-400 bg-main-400 ': form.aftermarkets,
							}"
							@click="toggleAftermarkets(true)"
						>
							<CheckSecondSvg
								v-if="form.aftermarkets"
								class="mb-1 h-6 w-6 fill-white"
								:class="{ 'opacity-0': !form.aftermarkets }"
							/>

							<div
								v-else
								class="h-[27px] w-[27px] rounded-full border border-gray-300"
							/>

							<span
								class="text-xl font-bold"
								:class="{ 'text-white': form.aftermarkets !== false }"
							>
								Yes
							</span>
						</div>
					</div>

					<AppInput
						v-if="form.aftermarkets"
						v-model="form.aftermarketsComment"
						type="text"
						input-class="max-[374px]:!w-60 py-2 pl-0 h-auto !w-80 sm:!w-96 rounded-none shadow-none focus:shadow-none !border-b-solid border-white border-b-main-300 focus:border-solid !focus:border-white focus:border-b-main-400 outline-none"
						placeholder="List them here"
					>
						<template #append>
							<PencilSvg
								class="xs:-right-8 absolute -top-2 -right-6 h-4 w-4 md:-top-1.5"
							/>
						</template>
					</AppInput>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { useFormStore } from '../../../stores/form'
	import CheckSecondSvg from '../components/icons/CheckSecondSvg.vue'
	import HelpfulTips from '../components/HelpfulTips.vue'
	import PencilSvg from '../components/icons/PencilSvg.vue'
	import AppInput from '../../common/AppInput.vue'

	// hooks
	const form = useFormStore()

	// methods
	const toggleAftermarkets = (value: boolean) => {
		if (!value) form.aftermarketsComment = ''
		form.aftermarkets = value
	}
</script>
